<template>
  <div class="hm-card landing blue-header-banner">
    <div class="header-banner">
      <h2>How Many People Are in Your Household?</h2>
      <p>
        This includes you, your spouse, children, and other relatives you support who live with you.
      </p>
    </div>
    <div class="max-w white">
      <div class="center" style="margin-top: 2em;">
        <div class="dependents-card">
          <p>
            Household Members
            <span class="tooltip-icon" v-tooltip="'Even if your annual income is higher than the limit, you may still qualify for Extra Help because you support other family members in your household.'">
              <img src="//hm-lis.herokuapp.com/img/svg/info-circle-solid.svg" alt="image">
            </span>
          </p>
          <div style="margin: 1em 6em 2em 6em;">
            <SuiDropdown
              placeholder="Select One"
              selection
              fluid
              :labeled="true"
              :options="howManyPeopleOptions"
              v-model="howManyPeople"
            />
          </div>
        </div>
        <SuiButton color="green" @click="() => goNextStep('final')">Next</SuiButton>
      </div>
    </div>
  </div>
</template>

<script>
  import PeopleInHousehold from '@/components/small/PeopleInHousehold';

  export default {
    extends: PeopleInHousehold,
  }
</script>
